import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import PrivateLayout from '@/layouts/PrivateLayout';
import { Helmet } from 'react-helmet-async';
import ReminderSettings from '@/features/scheduledReceipt/ReminderSettings';
import ReportDeliverySettings from '@/features/scheduledReceipt/ReportDeliverySettings';
import { useUser } from '@/hooks/UserContext';
import FirstTimeExperienceManager from '@/features/firstTimeExperience/FirstTimeExperienceManager';

/**
 * 配信（リマインダー・レポート）設定ページ
 */
function ScheduledReceipt(): ReactElement {
    const { t } = useTranslation('scheduledReceipt');
    const { userInfo } = useUser();

    return (
        <FirstTimeExperienceManager userInfo={userInfo}>
            <PrivateLayout>
                <Helmet>
                    <title>{t('meta.title')}</title>
                </Helmet>
                <div className="w-full max-w-7xl min-w-0 flex flex-col gap-6 px-4 py-5 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
                    <ReminderSettings />

                    <hr className="my-2" />

                    <div id="tutorial-delivery-report">
                        <ReportDeliverySettings />
                    </div>
                </div>
            </PrivateLayout>
        </FirstTimeExperienceManager>
    );
}

export default ScheduledReceipt;

